import React, { useCallback, useEffect, useState } from "react";
import "./orderTile.css";
import "../orderTile/logo.png";
import { orderTile } from "../../types/types";
import { formatNumberWithCommas, getTableData } from "../../services/analyticsService"; 
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import RenderSvg from "../renderSvg/RenderSvg";
import { TranslationEnum, usePortalTranslation } from "../../providers/TranslationProvider";
import { Skeleton } from '@mui/material';

export function OrderTile(props: orderTile) {
  const { translate } = usePortalTranslation();
  const CUR_COMPONENT = "Order Analytics"
  const CUR_COMPONENT_COMMON="commonPortal";
  const [orderPrimaryValue, setOrderPrimaryValue] = useState("");
  const [orderSecondaryValue, setOrderSecondaryValue] = useState("");
  const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => {

    const getOrderAnalyticsData = async () => {
      setLoading(true);
      try {
          if (props.callApi === true || props.callApi === undefined) {
            const responsePrimary = await getTableData(props.api !== undefined ? props.api : '');
            const responsePrimaryResult = (responsePrimary !== undefined && responsePrimary !== null) ? responsePrimary[0]?.value || 0 : 0 ;
            setOrderPrimaryValue(responsePrimaryResult);
  
            const responseSecondary = await getTableData(props.api2 !== undefined ? props.api2 : '');
            const responseSecondaryResult = (responseSecondary !== undefined && responseSecondary !== null) ? responseSecondary[0]?.value || 0 : 0 ;
            setOrderSecondaryValue(responseSecondaryResult);
          }
          else {
            setOrderPrimaryValue((props.orderPrimaryValue !== undefined && props.orderPrimaryValue !== null) ? props.orderPrimaryValue : "0");
            setOrderSecondaryValue((props.orderSecondaryValue !== undefined && props.orderSecondaryValue !== null) ? props.orderSecondaryValue : "0");
          }
      }
      catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };
    getOrderAnalyticsData();
  }, []);

  return (<>
    {
      (loading) ?
        (<Skeleton variant="rectangular" width={264} height={128} />) : <div className="order-tile">
          <div className="order-card-heading">

            <div>
              {typeof props.img === "string" ?
                <div className="order-tile-svg">
                  <RenderSvg name={props.img} svgColor={"#23c6b0"} />
                </div> :
                <div className="order-tile-image">
                  <FontAwesomeIcon icon={props.img} size="xs" style={{ color: "#23c6b0" }} />
                </div>}
            </div>
            <div className="heading-name">{translate(TranslationEnum.order_analytics,props.heading)}</div>
          </div>
          <div className="order-tile-main-container">
            <div className="today-data">
              <div style={{ fontWeight: 300, fontSize: "small" }}>{translate(TranslationEnum.order_analytics,props.subHeading)}</div>
              <div style={{ fontWeight: 600, fontSize: 16 }}>{formatNumberWithCommas(orderPrimaryValue)}</div>
            </div>
            {props?.footerHeading && orderSecondaryValue && 
            (props?.visible === undefined || props?.visible) &&(
              <div className="order-tile-footer-container">
                <div style={{ fontWeight: 500, color: "#5fc3b0", fontSize: "12px" }}>
                {translate(TranslationEnum.order_analytics,props.footerHeading)}
                </div>
                <div style={{ fontWeight: "bold", color: "#5fc3b0", fontSize: "12px" }}>
                {formatNumberWithCommas(orderSecondaryValue)} 
                </div>
              </div>
            )}
          </div>
        </div>
    }</>
  );
}
